import React, {useState} from 'react';
import Icon from '../../../assets/icons/icon';
import { UnixTimestampToDate } from '../../../utilities/timeFunctions';
import * as amplitude from "@amplitude/analytics-browser";

function CallbackDetail({details, formatDate,openLead}) {
    const isFeature868Enabled = process.env.REACT_APP_FUNNEL_FEATURE_868 === 'true'
    const isFeature984Enabled = process.env.REACT_APP_FUNNEL_FEATURE_984 === 'true'
    const [open, setOpen] = useState(false);
    const openUp=()=>{
        setOpen((prevOpen) => !prevOpen);
    }
	/**
	 * @param {PointerEvent} evt
	 */
	const rootClicked = (evt) => {
		evt.stopPropagation();
		try {
			amplitude.track(
				"Expand Section",
				{
					name: "CallbackDetail",
				}
			);
		} catch (err) {
			console.error(
				"rootClicked: Exception occurred during Amplitude communication attempt: %s",
				err,
				err,
			);
		}
		openUp();
	}
    return (
        <>
            <div className="quilityNestedBlockWrapper" onClick={rootClicked}>
                <div className='quilityNestedBlockHeader'>
                    <div className="quilityParentBlockTitle" style={{width: '170px'}}>Call Backs</div>
                    <span style={{marginLeft:'20px'}}>
                        <span className="typeBlock">{details.length} Callback{details.length > 1 || details.length < 1 ? 's': ''}</span>
                    </span>
                    <span className={`quilityBlockIcon ${!open ? 'rotate':''}`} style={{marginTop: '-5px', transition:'all .5s'}}><span className="fontello"><Icon name={'q-up'} size={20} className="closeIcon" adjust="fontello" /></span></span>
                </div>

                <div className={`detailWrapper ${open ? 'openUp' : ''}`}>
                    {details.map((detail, index) => (
                        <div className="detailItem" key={"callback"+index}>
                            <span className="detailTitle">{detail.schedLeadFirst} {detail.schedLeadLast}</span>
                            <span className="detailDate">{isFeature984Enabled ? UnixTimestampToDate(isFeature868Enabled===true ? detail.schedTime : detail.schedLead) :  formatDate(isFeature868Enabled===true ? detail.schedTime : detail.schedLead)}</span>
                            <span className="detailTimezone"></span>
                            <span className="ViewLead" onClick={(event) => { event.stopPropagation(); openLead(isFeature868Enabled===true ? detail.schedLead : detail.schedTime); }}>View Lead</span>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default CallbackDetail;